
export default {
  name: "Loader",
  props: {
    logo: String,
    spinnerClass: String
  }
};
